import { createSelector } from 'reselect'

import {
  getPageHomeSt,
  getPageHomeHeight,
  getViewportHeight,
} from '../app/selectors'

const getNavigation = state => state.navigation

const getApp = state => state.app

export const getNavigationBackPathname = createSelector(
  [getApp],
  app => {
    return app.get('backPathname')
  }
)

export const getHideArtists = createSelector(
  [getPageHomeSt, getPageHomeHeight, getViewportHeight],
  (st, dh, vh) => {
    return st > dh - vh * 2
  }
)

export const getNavigationMenuList = createSelector(
  [getNavigation],
  navigation => {
    return navigation.get('menu')
  }
)

export const getNavigationBackList = createSelector(
  [getNavigation],
  navigation => {
    return navigation.get('back')
  }
)

export const getNavigationOverArtists = createSelector(
  [getNavigation],
  (navigation) => {
    return navigation.get('overArtists')
  }
)

export const getNavigationActive = createSelector(
  [getNavigation],
  navigation => {
    return navigation.get('active')
  }
)




// WEBPACK FOOTER //
// ./src/components/navigation/selectors.js